import GearSvg from '@components/icons/Gear.svg';
import { formatCentsPrice } from '@helpers/formatCentsPrice';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { TopUpButton } from './components/TopUpButton';

export const UserPaymentModelStatus = () => {
  const { organization } = useAuthContext();
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    setBalance(organization?.billingAccount?.currentBalance || 0);
  }, [organization]);

  const canViewBilling = organization?.billingAccount && organization?.permissions?.viewBilling;
  if (!canViewBilling) {
    return null;
  }

  return (
    <div className="relative px-[15px]">
      <div className="pt-2">
        <div className="font-normal text-xs leading-4 text-foreground pb-2">Credit Balance</div>
        <div className="flex items-center">
          <RouterLink
            className="credit-balance-link no-underline hover:no-underline flex items-center text-left text-[var(--color-text-muted)] hover:text-[var(--color-title)] text-base font-semibold leading-none tracking-[0.16px]"
            to={routes.billingAccount.make(organization?.slug ?? '')}
          >
            {formatCentsPrice(balance)}
            <GearSvg style={{ width: '14px', height: '18px', marginLeft: '10px' }} />
          </RouterLink>
          <TopUpButton />
        </div>
      </div>
    </div>
  );
};
